import moment from "moment";

export const TIPO_PROGRAMACAO_BANNER = {
  SEGUIR_CARROSSEL: "seguir_carrossel",
  PERIODO: "periodo",
  DIAS_SEMANA: "dias_semana"
};

export const DIA_SEMANA_PROGRAMACAO = {
  SEGUNDA: "segunda",
  TERCA: "terca",
  QUARTA: "quarta",
  QUINTA: "quinta",
  SEXTA: "sexta",
  SABADO: "sabado",
  DOMINGO: "domingo"
};

const DIAS_SEMANA_VALIDOS = new Set(Object.values(DIA_SEMANA_PROGRAMACAO));

export const OPCOES_TIPO_PROGRAMACAO = [
  {
    text: "Seguir vigência do carrossel",
    value: TIPO_PROGRAMACAO_BANNER.SEGUIR_CARROSSEL
  },
  {
    text: "Definir período do banner",
    value: TIPO_PROGRAMACAO_BANNER.PERIODO
  },
  {
    text: "Exibir em dias específicos da semana",
    value: TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA
  }
];

export const DIAS_SEMANA_OPCOES = [
  { text: "Seg", value: DIA_SEMANA_PROGRAMACAO.SEGUNDA },
  { text: "Ter", value: DIA_SEMANA_PROGRAMACAO.TERCA },
  { text: "Qua", value: DIA_SEMANA_PROGRAMACAO.QUARTA },
  { text: "Qui", value: DIA_SEMANA_PROGRAMACAO.QUINTA },
  { text: "Sex", value: DIA_SEMANA_PROGRAMACAO.SEXTA },
  { text: "Sáb", value: DIA_SEMANA_PROGRAMACAO.SABADO },
  { text: "Dom", value: DIA_SEMANA_PROGRAMACAO.DOMINGO }
];

const DIA_SEMANA_ROTULO = {
  [DIA_SEMANA_PROGRAMACAO.SEGUNDA]: "segunda",
  [DIA_SEMANA_PROGRAMACAO.TERCA]: "terça",
  [DIA_SEMANA_PROGRAMACAO.QUARTA]: "quarta",
  [DIA_SEMANA_PROGRAMACAO.QUINTA]: "quinta",
  [DIA_SEMANA_PROGRAMACAO.SEXTA]: "sexta",
  [DIA_SEMANA_PROGRAMACAO.SABADO]: "sábado",
  [DIA_SEMANA_PROGRAMACAO.DOMINGO]: "domingo"
};

export const TEXTOS_PROGRAMACAO_BANNER = {
  titulo: "Programação de exibição",
  subtitulo: "Defina quando este banner será exibido.",
  infoSeguir:
    "A programação é individual para cada banner. O período e os dias selecionados devem respeitar a vigência do carrossel.",
  hintPeriodo: "Selecione um período dentro da vigência do carrossel.",
  infoPeriodo:
    "A programação é individual para cada banner. O período selecionado deve respeitar a vigência do carrossel.",
  hintDias: "Selecione um ou mais dias da semana.",
  hintDiasSemanal:
    "O banner será exibido semanalmente nos dias selecionados, dentro da vigência do carrossel.",
  infoDias:
    "A programação é individual para cada banner. Fora dos dias selecionados, este banner não será exibido."
};

export const programacaoPadraoBanner = () => ({
  tipo: TIPO_PROGRAMACAO_BANNER.SEGUIR_CARROSSEL
});

const tipoProgramacaoValido = tipo => {
  const valor = `${tipo || ""}`.trim();
  if (valor === TIPO_PROGRAMACAO_BANNER.SEGUIR_CARROSSEL) {
    return TIPO_PROGRAMACAO_BANNER.SEGUIR_CARROSSEL;
  }
  if (valor === TIPO_PROGRAMACAO_BANNER.PERIODO) {
    return TIPO_PROGRAMACAO_BANNER.PERIODO;
  }
  if (valor === TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA) {
    return TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA;
  }
  return null;
};

const normalizarDiasSemana = dias => {
  if (!Array.isArray(dias)) return [];
  return dias
    .map(dia => `${dia || ""}`.trim())
    .filter(dia => DIAS_SEMANA_VALIDOS.has(dia));
};

const parseDataProgramacao = valor => {
  if (!valor) return null;
  const parsed = moment(valor);
  return parsed.isValid() ? parsed : null;
};

const rotuloBanner = (slide, indice) => `Banner ${indice + 1}`;

export const normalizarProgramacaoBanner = programacao => {
  if (!programacao || typeof programacao !== "object") {
    return programacaoPadraoBanner();
  }

  const tipo = tipoProgramacaoValido(programacao.tipo);
  if (!tipo) {
    return programacaoPadraoBanner();
  }

  if (tipo === TIPO_PROGRAMACAO_BANNER.SEGUIR_CARROSSEL) {
    return programacaoPadraoBanner();
  }

  if (tipo === TIPO_PROGRAMACAO_BANNER.PERIODO) {
    return {
      tipo: TIPO_PROGRAMACAO_BANNER.PERIODO,
      inicio: programacao.inicio || null,
      termino: programacao.termino || null
    };
  }

  return {
    tipo: TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA,
    diasSemana: normalizarDiasSemana(programacao.diasSemana)
  };
};

export const montarProgramacaoPayload = programacao => {
  const normalizada = normalizarProgramacaoBanner(programacao);

  if (normalizada.tipo === TIPO_PROGRAMACAO_BANNER.PERIODO) {
    return {
      tipo: TIPO_PROGRAMACAO_BANNER.PERIODO,
      inicio: normalizada.inicio,
      termino: normalizada.termino
    };
  }

  if (normalizada.tipo === TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA) {
    return {
      tipo: TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA,
      diasSemana: [...(normalizada.diasSemana || [])]
    };
  }

  return programacaoPadraoBanner();
};

export const formatarVigenciaCarrosselReferencia = (inicio, fim) => {
  if (!inicio && !fim) return "";
  const inicioFmt = inicio ? moment(inicio).format("DD/MM/YYYY") : "—";
  const fimFmt = fim ? moment(fim).format("DD/MM/YYYY") : "—";
  return `Vigência do carrossel: ${inicioFmt} a ${fimFmt}`;
};

const formatarPeriodoRevisao = (inicio, termino) => {
  const inicioFmt = inicio ? moment(inicio).format("DD/MM/YYYY HH:mm") : "—";
  const terminoFmt = termino ? moment(termino).format("DD/MM/YYYY HH:mm") : "—";
  return `${inicioFmt} a ${terminoFmt}`;
};

const formatarListaDias = dias => {
  const rotulos = normalizarDiasSemana(dias)
    .map(dia => DIA_SEMANA_ROTULO[dia])
    .filter(Boolean);

  if (!rotulos.length) return "";
  if (rotulos.length === 1) return rotulos[0];
  if (rotulos.length === 2) return `${rotulos[0]} e ${rotulos[1]}`;

  return `${rotulos.slice(0, -1).join(", ")} e ${rotulos[rotulos.length - 1]}`;
};

export const formatarProgramacaoRevisao = programacao => {
  const normalizada = normalizarProgramacaoBanner(programacao);

  if (normalizada.tipo === TIPO_PROGRAMACAO_BANNER.PERIODO) {
    return formatarPeriodoRevisao(normalizada.inicio, normalizada.termino);
  }

  if (normalizada.tipo === TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA) {
    const dias = formatarListaDias(normalizada.diasSemana);
    return dias || "Dias da semana";
  }

  return "Segue o carrossel";
};

export const validarProgramacaoBanner = (
  programacao,
  vigencia = {},
  slide = {},
  indice = 0
) => {
  const normalizada = normalizarProgramacaoBanner(programacao);
  const label = rotuloBanner(slide, indice);

  if (normalizada.tipo === TIPO_PROGRAMACAO_BANNER.SEGUIR_CARROSSEL) {
    return { valid: true };
  }

  if (normalizada.tipo === TIPO_PROGRAMACAO_BANNER.DIAS_SEMANA) {
    if (!normalizada.diasSemana.length) {
      return {
        valid: false,
        message: `${label}: selecione ao menos um dia da semana`
      };
    }
    return { valid: true };
  }

  const inicioBanner = parseDataProgramacao(normalizada.inicio);
  const terminoBanner = parseDataProgramacao(normalizada.termino);

  if (!inicioBanner || !terminoBanner) {
    return {
      valid: false,
      message: `${label}: informe o início e o término do período`
    };
  }

  if (!terminoBanner.isAfter(inicioBanner)) {
    return {
      valid: false,
      message: `${label}: o término deve ser posterior ao início`
    };
  }

  const inicioCarrossel = parseDataProgramacao(vigencia.inicio);
  const fimCarrossel = parseDataProgramacao(vigencia.fim);

  if (!inicioCarrossel || !fimCarrossel) {
    return {
      valid: false,
      message: `${label}: programação por período exige vigência do carrossel`
    };
  }

  if (inicioBanner.isBefore(inicioCarrossel)) {
    return {
      valid: false,
      message: `${label}: o início não pode ser anterior à vigência do carrossel`
    };
  }

  if (terminoBanner.isAfter(fimCarrossel)) {
    return {
      valid: false,
      message: `${label}: o término não pode ser posterior à vigência do carrossel`
    };
  }

  return { valid: true };
};

export const validarProgramacaoSlides = (slides = [], vigencia = {}) => {
  const banners = (slides || []).filter(slide => slide?.image);

  for (let indice = 0; indice < banners.length; indice += 1) {
    const resultado = validarProgramacaoBanner(
      banners[indice].programacao,
      vigencia,
      banners[indice],
      indice
    );
    if (!resultado.valid) {
      return resultado;
    }
  }

  return { valid: true };
};

export const periodoBannerForaDaVigencia = (programacao, vigencia = {}) => {
  const normalizada = normalizarProgramacaoBanner(programacao);
  if (normalizada.tipo !== TIPO_PROGRAMACAO_BANNER.PERIODO) {
    return false;
  }

  const inicioBanner = parseDataProgramacao(normalizada.inicio);
  const terminoBanner = parseDataProgramacao(normalizada.termino);
  const inicioCarrossel = parseDataProgramacao(vigencia.inicio);
  const fimCarrossel = parseDataProgramacao(vigencia.fim);

  if (!inicioBanner || !terminoBanner || !inicioCarrossel || !fimCarrossel) {
    return false;
  }

  return (
    inicioBanner.isBefore(inicioCarrossel) ||
    terminoBanner.isAfter(fimCarrossel)
  );
};

export const listarBannersPeriodoForaDaVigencia = (
  slides = [],
  vigencia = {}
) => {
  return (slides || [])
    .filter(slide => slide?.image)
    .map((slide, indice) => ({ slide, indice }))
    .filter(({ slide }) =>
      periodoBannerForaDaVigencia(slide.programacao, vigencia)
    )
    .map(({ slide, indice }) => ({
      indice,
      id: slide.id,
      label: rotuloBanner(slide, indice)
    }));
};

export const mensagemBannersForaDaVigencia = banners => {
  if (!banners.length) return "";
  if (banners.length === 1) {
    return `${banners[0].label}: ajuste o período. Ele ficou fora da vigência do carrossel`;
  }

  const labels = banners.map(banner => banner.label);
  return `Ajuste o período de ${labels.join(
    ", "
  )}. Eles ficaram fora da vigência do carrossel`;
};

export const mergeProgramacaoSlide = (currentSlide, nextSlide) => {
  if (currentSlide?.programacao) {
    return currentSlide.programacao;
  }
  return nextSlide?.programacao;
};
